var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef } from "react";
import useOutSideClick from "@frameworks/web/components/generic/customHooks/useOutSideClick";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var SearchDropdown = function (props) {
    var _a, _b;
    var device = DeviceContext();
    var _c = __read(React.useState(false), 2), open = _c[0], SetOpen = _c[1];
    var ref = useRef(null);
    var handleOpen = function () {
        SetOpen(!open);
    };
    useOutSideClick(ref, function () { return SetOpen(false); });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "search-dropdown-genblock", ref: ref },
            React.createElement("label", { onClick: !(props === null || props === void 0 ? void 0 : props.disabled) ? handleOpen : undefined, className: "dropdown-title d-space-between hand_cursor ".concat(open
                    ? "txt-midnight-blue bg_aqua_white"
                    : "txt_secondary-gray bg_white") },
                React.createElement("div", { className: "".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "DMSan_14_500" : "DMsanR_10_400 lh-140") },
                    props.title,
                    "\u00A0"),
                React.createElement("span", { className: "edel-icon-arrow-down ".concat(open ? "rotate txt-midnight-blue" : "txt-midnight-blue") })),
            open && (React.createElement("div", { className: "dropdown-list" }, ((_a = props.list) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                ((_b = props.list) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                    var _a;
                    return (React.createElement("div", { key: item.value, className: "radio-button-search d-flex " },
                        React.createElement("label", { className: "radio_btn hand_cursor d-flex align-items-center" },
                            React.createElement("input", { className: "hand_cursor", type: "radio", value: item.value, name: props.name, checked: ((_a = props.selected) === null || _a === void 0 ? void 0 : _a.findIndex(function (x) { return x === item.value; })) > -1, onChange: function (e) {
                                    props.onChange(e);
                                    SetOpen(false);
                                } }),
                            React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1 pdl-10" }, item.display))));
                })))))));
};
export default SearchDropdown;
